import React, {FC, FormEvent, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from "axios";
import createPersistentStorage from "../../persistent-storage";
// import {useNavigate} from "react-router-dom";
import styles from './Login.module.scss';
import '../../sharedAdmin.scss'
import {react_app_backend_url} from "../../globalApi";

const accessTokenStorage = createPersistentStorage<string>("access_token");

interface LoginProps {}

export const Login: FC<LoginProps> = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");
    // const navigate = useNavigate();

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        //Prevent page reload
        event.preventDefault();
        setError("");

        let formData = new FormData(event.currentTarget);

        axios.post(react_app_backend_url + "/login",
            formData,
            {headers: {'Content-Type': 'multipart/form-data'}, validateStatus: () => true})
            .then((response) => {
                if (response.status === 200 ) {
                    accessTokenStorage.write(response.data.token)
                    window.location.href = "/"
                }
                if (response.status !== 200) {
                    setError(response.status == 401 ? "Invalid username or password" : `Error when attempting to log in: ${response.status}`)
                    setIsSubmitting(false);
                }
            }, error => {
                console.error("error", error)
                setError(error);
            }).finally(() => setIsSubmitting(false));
    };

    // const navigateToApp = () => navigate("/");

    // JSX code for login form
    const renderForm = (
        <div className="form">
            <span style={{"color":"red"}}>{error}</span>
            <form onSubmit={handleSubmit}>
                <div className="input-container">
                    <label>User </label>
                    <input type="text" name="username" id="username" required/>
                </div>
                <div className="input-container">
                    <label>Password </label>
                    <input type="password" name="password" id="password" required/>
                </div>
                <div className="button-container">
                    <button type="submit" disabled={isSubmitting}>Log in</button>
                </div>
            </form>
        </div>
    );

    return (
        <div className={styles.app}>
            <div className="login-form box">
                <h1>Log in</h1>
                {renderForm}
            </div>
        </div>
    );
};
